import { render, staticRenderFns } from "./TransferenciaPosseDefinitivaForm.vue?vue&type=template&id=c3364efe&lang=html&"
import script from "./TransferenciaPosseDefinitivaForm.vue?vue&type=script&lang=js&"
export * from "./TransferenciaPosseDefinitivaForm.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciaPosseDefinitivaForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/transferencia-posse/definitiva/TransferenciaPosseDefinitivaForm.vue
// module id = 1573
// module chunks = 28